export default __webpack_public_path__ + "static/media/m2_video_ntF.ddf812d5.png";